<template>
  <span
    v-if="shouldShowDueToday && priceDueToday"
    class="text-static-default-low body-2"
  >
    {{ i18n(selectedTranslation, { price: i18n.price(priceDueToday) }) }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import type { GetOfferV1Response } from '@backmarket/http-api/src/api-specs-buyback/customer/getOfferV1'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../PriceLabel.translations'

const props = defineProps<{
  buybackOffer: GetOfferV1Response | null
  priceDueToday?: Price | null
  isWithAfterTradeInPriceLegalChangeEnabled?: boolean
}>()

const i18n = useI18n()

const isSwapActive = computed(() => {
  return Boolean(props.buybackOffer)
})

const shouldShowDueToday = computed(() => {
  return Boolean(isSwapActive.value && props.priceDueToday)
})

const selectedTranslation = computed(() => {
  return props.isWithAfterTradeInPriceLegalChangeEnabled
    ? translations.priceToday
    : translations.dueToday
})
</script>
